export const LoginType = {
    EmailPassword: 0,
    Office365: 2,
    Google: 3
}